// Typelizer digest bf521ac0e5a678f5d2388df32aa63c4f
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /accountant/firm */
  show: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/accountant/firm', {}, options),
    method: 'get',
  }),
}
